import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/podcasts/$channelUid/settings/")({
	beforeLoad({ params }) {
		throw redirect({
			to: "/podcasts/$channelUid/settings/details",
			params,
		});
	},
});
